import { memo, useCallback, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { ReactionType, addReaction } from '@/data/api/comment'
import styles from './comments.module.scss'

type Props = {
  type: ReactionType
  emoji: string
  count: number
  commentId: string
  disabled?: boolean
}

const Reaction = ({ type, emoji, count: initalCount, commentId, disabled }: Props) => {
  const isLoading = useRef(false)
  const [ count, setCount ] = useState(initalCount || 0)

  const onClick = useCallback(async () => {
    if (isLoading.current || disabled) {
      return
    }
    isLoading.current = true
    const result = await addReaction(type, commentId)
      .catch((error) => ({ error }))
    if (result.error) {
      // eslint-disable-next-line no-console
      console.error(result.error)
      isLoading.current = false
      return
    }
    setCount(result.newCount)
    isLoading.current = false
  }, [ commentId, type, disabled ])

  useEffect(() => {
    setCount(initalCount)
  }, [ initalCount ])

  return (
    <div className="tx-12 mr-1">
      <button
        type="button"
        className={classNames(styles.reactionBtn, disabled && styles.disabled)}
        aria-label="+1"
        onClick={onClick}
      >
        <span role="img" aria-label="plus">
          {emoji}
        </span>
        <span className="tx-10 tx-g800">{count || ''}</span>
      </button>
    </div>
  )
}

export default memo(Reaction)
